import { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "@/common/utils/device";
import ChevronRightIcon from "./images/icons/chevron-right.svg?react";
import "./NewSeeMoreBlock.scss";
import { metricsBus, SearchResultSection } from "@/common/buses";

interface INewSeeMoreBlock {
  children: React.ReactNode;
  title: string | React.ReactNode;
  moreLink: string;
  section?: SearchResultSection;
}

export const NewSeeMoreBlock: React.FC<INewSeeMoreBlock> = ({
  children,
  title,
  moreLink,
  section
}) => {
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);
  const onSeeAllClick = useCallback(() => {
    metricsBus.emit("seeAllButtonClicked", {
      section,
    });
  }, [section]);

  const SeeAllButton = useMemo(() => (
    <Link className="Button Button_ghost Button_s" to={moreLink} onClick={onSeeAllClick} rel="nofollow">See All <ChevronRightIcon /></Link>
  ), [moreLink]);

  return (
    <div className="NewSeeMoreBlock">
      <div className="NewSeeMoreBlock-Header">
        <h2 className="NewSeeMoreBlock-Title">{title}</h2>
        {isDesktop && SeeAllButton}
      </div>
      <div className="NewSeeMoreBlock-Cnt">
        {children}
      </div>
      {!isDesktop && (
        <div className="NewSeeMoreBlock-Footer">
          {SeeAllButton}
        </div>
      )}
    </div>
  );
};
